"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Recipients/AddRecipientsMenu.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Button = require('web/components/Form/Button/Button');
var _MenuItem = require('web/screens/Broadcast/MenuItem'); var _MenuItem2 = _interopRequireDefault(_MenuItem);
var _useMenuButton = require('web/screens/Broadcast/useMenuButton'); var _useMenuButton2 = _interopRequireDefault(_useMenuButton);
var _DisabledReason = require('web/screens/Broadcast/DisabledReason'); var _DisabledReason2 = _interopRequireDefault(_DisabledReason);
var _addingRecipients = require('web/screens/Broadcast/addingRecipients');













/* Rev 30 Z1 / Rev 31 v2 frame 2: Add existing and Add from CSV, each
 * opening its dialog (Rev 34 S3: no hint lines). */
const AddRecipientsMenu = ({
  label, campaignKey, isDisabled: isDisabledProp = false, onAddExisting, onAddFromCsv, className,
}) => {
  const isAddingRecipients = _addingRecipients.useIsAddingRecipients.call(void 0, campaignKey)
  const isDisabled = isDisabledProp || isAddingRecipients
  const reason = isAddingRecipients && !isDisabledProp ? _addingRecipients.ADD_RUNNING_REASON : null
  const menu = _useMenuButton2.default.call(void 0, { isDisabled })

  // Focus is on the button when the dialog opens, so it returns there.
  const choose = (open) => () => {
    menu.close()
    open()
  }

  return (
    _react2.default.createElement('div', { ref: menu.rootRef, className: _classBuilder2.default.call(void 0, 'recipients-add', className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
      , _react2.default.createElement(_DisabledReason2.default, { reason: reason, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
        , _react2.default.createElement('button', {
          ...menu.triggerProps,
          type: "button",
          disabled: isDisabled,
          className: _classBuilder2.default.call(void 0, _Button.btnClassName, _Button.secondaryBtnClassName, 'recipients-add--button'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}

          , _react2.default.createElement('img', { src: "/assets/icons/add-participant-black.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}} )
          ,  label 
          , _react2.default.createElement('span', { className: "recipients-add--caret", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}, "▾")
        )
      )
      ,  menu.isOpen && (
        _react2.default.createElement('div', { ...menu.menuProps, 'aria-label': label, className: "broadcast-menu recipients-add--menu" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}
          , _react2.default.createElement(_MenuItem2.default, {
            label: "Add existing" ,
            iconSrc: "/assets/icons/add-participant-black.svg",
            onClick: choose(onAddExisting), __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
          )
          , _react2.default.createElement(_MenuItem2.default, {
            label: "Add from CSV"  ,
            iconSrc: "/assets/icons/header/file-dark.svg",
            onClick: choose(onAddFromCsv), __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
          )
        )
      )
    )
  )
}

exports. default = AddRecipientsMenu
